import { features } from '@/mocks/movies';

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择被窝影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            三大核心优势，重新定义免费在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}